import React from 'react';
import styled from 'styled-components';
import type { TourGuideItem } from '../../../../types';

interface MobileItemProps extends TourGuideItem {
  onClickButton: () => void;
}

export const TourGuideMobileModal = ({
  image,
  text,
  title,
  buttonText,
  onClickButton,
}: MobileItemProps) => (
  <Content>
    <ImageWrapper>
      <Image src={image.src} />
    </ImageWrapper>
    <Title>{title}</Title>
    <Text>{text}</Text>

    <Button onClick={onClickButton}>{buttonText}</Button>
  </Content>
);

const Content = styled.section`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

const ImageWrapper = styled.div`
  @media (max-height: 1023px) {
    width: 280px;
    height: 280px;
  }
  @media (max-height: 700px) {
    width: 250px;
    height: 250px;
  }
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  flex-grow: 1;
`;

const Image = styled.img`
  width: 100%;
`;

const Title = styled.div`
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  padding-left: 16px;
  margin-bottom: 8px;
  margin-top: auto;
  color: #000;
`;

const Text = styled.div`
  font-size: 14px;
  line-height: 16px;
  padding: 0 16px;
  margin-bottom: 16px;
  color: #000;
`;

export const Button = styled.div`
  background-color: #ff611d;
  color: #ffffff;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 16px 0px;
  margin: 0 16px 0;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  cursor: pointer;
`;
